import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
    fetchPublicacion,
    editPublicacion,
    fetchTiposPublicacion,
    fetchVariaciones,
    setImagesUploader,
    resetPublicaciones,
    fetchPublicacionesEncabezado,
    fetchAtributosCategoria,
    fetchEstructuraAtributosValores
} from '../../../../actions/publicacionesActions';
import { formatCurrencyToNumber } from '../../../../helper/publicacionHelper';
import { createPublicacionApi, createImageUrl, CargarAtributosApi } from '../../../../api/axios';
import { toast } from 'react-toastify';
import Tab from '../../../General/Tab'
import DatosBasicos from './DatosBasicos';
import PrecioPago from './PrecioPago';
import Entrega from './Entrega';
import Imagenes from './Imagenes';
import Estado from './Estado';
import Garantia from './Garantia';
import GoBackArrow from '../../../General/GoBackArrow';
import PublicacionesAtributos from './PublicacionesAtributos';
import PropTypes from 'prop-types';

// Wrapper para usar hooks en class component
function PublicacionNewWrapper(props) {
    const navigate = useNavigate();
    const { idSeller } = useParams();
    const location = useLocation();
    return <PublicacionNew {...props} navigate={navigate} idSeller={idSeller} location={location} />;
}

class PublicacionNew extends React.Component {
    constructor(props) {
        super(props);
        this.tituloInputRef = React.createRef();
        this.state = {
            atLeastOneCreated: false,
            activeTab: 0,
            resetFlag: false,
            tabs: [
                { name: "Datos Básicos ", icon: "ti-home", content: <DatosBasicos isEditing={false} tituloRef={this.tituloInputRef} /> },
                { name: "Precio y Medio de Pago", icon: "sl-icon-wallet", content: <PrecioPago isEditing={false} /> },
                { name: "Entrega ", icon: "sl-icon-globe", content: <Entrega inCreate={true} /> },
                { name: "Imagenes ", icon: "sl-icon-picture", content: <Imagenes inCreate={true} /> },
                { name: "Estado ", icon: "sl-icon-layers", content: <Estado inCreate={true} /> },
                { name: "Garantía ", icon: "ti-home", content: <Garantia idSeller={this.props.idSeller} id={this.props.id} isEditing={true} /> },
                { name: "Caracteristicas ", icon: "ti-home", content: <PublicacionesAtributos isEditing={false} /> },
            ],
            refrescarAtributos: true,
        }
    };

    componentDidMount() {
        this.props.setImagesUploader([], false);
        this.props.fetchPublicacion(undefined, this.props.idSeller);
        this.props.fetchTiposPublicacion(this.props.idSeller);
        this.props.fetchVariaciones();
    }

    onSubmit = async (event, shouldRedirect = true) => {
        if (event && typeof event.preventDefault === 'function') {
            event.preventDefault();
        }

        const updatedImages = await this.updateImagenes();
        let publicacion = { ...this.props.publicacion };

        let request = {
            masivaBulks: [
                {
                    idSeller: publicacion.idSeller,
                    observacion: publicacion.observacion,
                    titulo: publicacion.titulo,
                    ean: publicacion.ean,
                    precioLista: formatCurrencyToNumber(publicacion.precioLista),
                    precioPromocional: publicacion.precioPromocional !== null ? formatCurrencyToNumber(publicacion.precioPromocional) : 0,
                    linkYoutube: publicacion.linkYoutube,
                    descripcionAmpliada: publicacion.descripcionAmpliada,
                    tipoEntrega: this.state.tipoEntrega || 1,
                    envioGratis: publicacion.envioGratis,
                    dimensiones: publicacion.dimensiones.map(dimension => ({
                        alto: dimension.alto !== undefined ? Number.parseFloat(dimension.alto) : 0,
                        ancho: dimension.ancho !== undefined ? Number.parseFloat(dimension.ancho) : 0,
                        profundidad: dimension.profundidad !== undefined ? Number.parseFloat(dimension.profundidad) : 0,
                        peso: dimension.peso !== undefined ? Number.parseFloat(dimension.peso) : 0,
                    })),
                    categoria: publicacion.categoria,
                    marca: publicacion.marca,
                    skuSeller: publicacion.skuSeller,
                    stock: publicacion.stock,
                    imagenes: updatedImages.map((img, index) => ({
                        posicion: img.posicion ?? index + 1,
                        urlImagen: img.urlImagen,
                    })),
                    idTipoPublicacion: Number.parseInt(publicacion.idTipoPublicacion, 10),
                    envioPropio: publicacion.envioPropio,
                    codigoLegibilidad: publicacion.codigoLegibilidad,
                    garantiaExtActiva: publicacion.garantiaExtActiva,
                    garantiaFabrica: publicacion.garantiaFabrica,
                    idMoneda: publicacion.idMoneda,
                    alicuotaIva: Number.parseFloat(publicacion.alicuotaIva),
                    alicuotaImpuestoInterno: publicacion.alicuotaImpuestoInterno != null ? publicacion.alicuotaImpuestoInterno : 0,
                    envioGratisZona: {
                        amba: true,
                        interior: true,
                        patagonia: true
                    },
                },
            ],
            idUser: this.props.userId,
        }


        try {

            const resp = await createPublicacionApi(request);

            toast.success("Publicación creada");
            this.setState({ atLeastOneCreated: true });

            const skuMarket =
                resp?.publicacion?.[0]?.skuMarket ??
                resp?.data?.publicacion?.[0]?.skuMarket;

            if (this.props.huboCambiosEstructuraAtributosValores) {
                await this.cargarAtributos(skuMarket);
            }

            if (!shouldRedirect) {
                this.resetForm();
            } else {
                this.props.navigate("/Publicaciones", { state: { onSubmitSuccess: true } });
            }

        } catch (err) {
            if (err.response?.data?.errores) {
                err.response.data.errores.forEach(e => toast.error(e));
            } else {
                toast.warn("No pudo crearse la publicación.");
            }
        }

    }

    updateImagenes = async () => {
        const updatedImages = [...this.props.imagesUploader];

        await Promise.all(
            updatedImages.map(async (img, index) => {
                if (img.imagen) {
                    const res = await createImageUrl(img.imagen);
                    if (res !== "") {
                        updatedImages[index] = {
                            ...img,
                            urlImagen: res.url,
                            posicion: index + 1,
                        };
                    }
                }
            })
        );

        return updatedImages;
    };

    cargarAtributos = async (skuMarket) => {
        try {
            const payload = {
                ...this.props.productoValores,
                codProducto: String(skuMarket)
            };

            await CargarAtributosApi(payload);
            toast.success("Características cargadas con éxito");
        } catch (err) {
            if (err.response?.data?.errores) {
                err.response.data.errores.forEach(error => toast.error(error));
            } else {
                toast.error("No se pudo actualizar las Características");
            }
        }
    };

    onSubmitSimple = (event) => {
        event.preventDefault();
        this.onSubmit(() => {
            this.goToPublicaciones();
        });
    };

    onSubmitAndReset = async (event) => {
        if (event) event.preventDefault();

        try {
            await this.onSubmit(event, false);
            this.resetForm();
        } catch {
            // Si hay errores, ya están manejados en `onSubmit`
        }
    };

    resetForm = () => {
        const updatedPublicacion = {
            ...this.props.publicacion,
            titulo: "",
            ean: "",
            precioLista: null,
            precioPromocional: null,
            descripcionAmpliada: "",
            dimensiones: [{ alto: 0, ancho: 0, profundidad: 0, peso: 0 }],
            categoria: undefined,
            marca: undefined,
            stock: 0,
            skuSeller: "",
            imagenes: [],
            idTipoPublicacion: 0,
            garantiaFabrica: 0,
            alicuotaIva: undefined,
            alicuotaImpuestoInterno: null
        };

        this.props.editPublicacion(updatedPublicacion);

        this.setState(prevState => (
            { resetFlag: !prevState.resetFlag, activeTab: 0 }), // Regresa a "Datos Básicos" (índice 0)
            () => {
                // Enfocar después del reset
                setTimeout(() => {
                    if (this.tituloInputRef?.current) {
                        this.tituloInputRef.current.focus();
                    }
                }, 0);
            }
        );
    };

    handleCancel = () => {
        const { atLeastOneCreated } = this.state;
        this.props.navigate("/Publicaciones", {
            state: {
                shouldFetch: atLeastOneCreated, // Solo permite fetch si la creación fue exitosa.
            },
        });
    };

    goToPublicaciones = () => {
        this.props.navigate("/Publicaciones");
    };

    render() {
        const { sellerName } = this.props;
        const { tabs, activeTab } = this.state;

        return (
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body p-b-0">
                        <GoBackArrow />
                        <h4 className="card-title d-block d-sm-inline">Nueva Publicacion</h4>
                        <h5 className="card-subtitle"> {sellerName} </h5>

                        <ul className="nav nav-tabs customtab">
                            {tabs.map((tab, index) => {
                                if (tab.name !== undefined) {
                                    return (
                                        <button key={tab.name} onClick={() => { this.setState({ activeTab: index }) }} style={{ border: "none", background: "none" }}>
                                            <Tab
                                                name={tab.name}
                                                icon={tab.icon}
                                                isActive={index === activeTab}
                                            />
                                        </button>
                                    );
                                }
                                return null;
                            })}
                        </ul>

                        <form className="form-horizontal form-material p-10">
                            <div className="tab-content">
                                {/* 🔹 1) Render habitual para todas las tabs MENOS Características */}
                                {activeTab !== 6 && React.cloneElement(tabs[activeTab].content, {
                                    resetFlag: this.state.resetFlag,
                                })}

                                {/* 🔹 2) Render SIEMPRE MONTADO para la tab Características */}
                                <div
                                    style={{
                                        display: activeTab === 6 ? 'block' : 'none'
                                    }}
                                >
                                    {React.cloneElement(tabs[6].content, {
                                        resetFlag: this.state.resetFlag,
                                    })}
                                </div>


                                <div className="text-center mt-1">
                                    <button
                                        onClick={this.onSubmitAndReset}
                                        className="btn btn-sm background-rojo-megatone waves-light m-r-10"
                                    >
                                        Guardar y Crear
                                    </button>
                                    <button
                                        onClick={this.onSubmitSimple}
                                        className="btn btn-sm background-rojo-megatone waves-light m-r-10"
                                    >
                                        Guardar
                                    </button>
                                    <button
                                        onClick={this.handleCancel}
                                        className="btn btn-sm btn-light waves-effect waves-light"
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
PublicacionNew.propTypes = {
    // Hooks props
    navigate: PropTypes.func,
    // Redux props
    idSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    publicacion: PropTypes.shape({
        imagenes: PropTypes.array,
    }),
    imagesUploader: PropTypes.array,
    productoValores: PropTypes.array,
    sellerName: PropTypes.string,
    huboCambiosEstructuraAtributosValores: PropTypes.bool,
    // Actions props
    setImagesUploader: PropTypes.func,
    editPublicacion: PropTypes.func,
    fetchPublicacion: PropTypes.func,
    fetchTiposPublicacion: PropTypes.func,
    fetchVariaciones: PropTypes.func,
}

const mapStateToProps = state => ({
    publicacion: state.publicaciones.publicacion,
    sellerName: state.general.userName,
    userId: state.general.userId,
    imagesUploader: state.publicaciones.imagesUploader,
    productoValores: state.publicaciones.productoValores,
    huboCambiosEstructuraAtributosValores: state.publicaciones.huboCambiosEstructuraAtributosValores
});

export default connect(mapStateToProps, {
    fetchPublicacion,
    editPublicacion,
    fetchTiposPublicacion,
    fetchVariaciones,
    setImagesUploader,
    resetPublicaciones,
    fetchPublicacionesEncabezado,
    fetchAtributosCategoria,
    fetchEstructuraAtributosValores,
    CargarAtributosApi
})(PublicacionNewWrapper);